// your main JavaScript file

// imports --------------------------------------------------------------------
import * as Cookies from './0-cookies-v3.8.js';
import * as Vars from './0-vars';
import * as Listeners from './1-listeners.js';
import * as Once from './2-once.js';
import * as Page from './3-page.js';
import * as Resize from './4-resize.js';
import * as Scroll from './5-scroll.js';
import * as Load from './6-load.js';
import * as MediaItems from './6-media-items-v1.7.js';
import * as VideoEmbed from './6-video-embed-v2.5.js';
// import * as MyHistory from './wb-history-v2.0.js';

// exported variables ---------------------------------------------------------

// local variables ------------------------------------------------------------
let domReady = false;

// functions -------------------------------------------------------------------
const init = () => {
  // console.log("init", Date.now());

  Cookies.initCookies();
  Vars.initVars();
  Listeners.initListeners();
  Once.initOnce();
  Page.setPage();
  if (Once.useHistoryNavigation) {
    Page.setPageAfterSetScroll({
      prepareFaderForViewTransition: false, // no skiponloadinview delay
      delay: false, // no delay
    }); 
  }
  Resize.initResize();
  Scroll.initScroll();
  MediaItems.initMediaItems();
  VideoEmbed.initVideoEmbed();
  // MyHistory.initHistory();

  // console.log('init done');
};

const tryInit = () => {
  if (domReady && window.blPageRevealed) init();
};

// register tryInit so render-blocking.js can call it
window.blTryInit = tryInit;

document.addEventListener('DOMContentLoaded', () => {
  // console.log('DOMContentLoaded', Date.now(), {pageRevealed: window.blPageRevealed});
  domReady = true;
  tryInit();
});

window.addEventListener('load', Load.loadedPage);

// console.log('This is the main JavaScript file.');
